// auth.js
export const LOGOUT = "LOGOUT";
export const SAVE_TOKEN = "SAVE_TOKEN";
export const FETCH_USER = "FETCH_USER";
export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const FETCH_USER_FAILURE = "FETCH_USER_FAILURE";
export const UPDATE_USER = "UPDATE_USER";
export const SET_TOKEN_EXPIRATION = "SET_TOKEN_EXPIRATION";

// feedback.js
export const RESPONSE_MSG = "RESPONSE_MSG";
export const CLEAR_MSG = "CLEAR_MSG";

// course.js
export const CHANGE_COURSE = "CHANGE_COURSE";
export const CLEAR_COURSE = "CLEAR_COURSE";
export const SAVE_COURSE_SESSIONS = "SAVE_COURSE_SESSIONS";
export const FETCH_COURSE_SESSIONS = "FETCH_COURSE_SESSIONS";

// settings
export const UPDATE_SETTINGS = "UPDATE_SETTINGS";
export const FETCH_SETTINGS = "FETCH_SETTINGS";

// chat.js
export const CHAT_SET_ACTIVE = 'CHAT_SET_ACTIVE';
export const CHAT_SET_MINIMIZED = 'CHAT_SET_MINIMIZED';